import { mergeMessagePatch } from 'store/app/entities/messages/mergeMessagePatch';

/**
 * Upsert a socket `newMessage` into the RTK Query `listMessages` cache draft.
 *
 * The backend re-emits the SAME message _id when late data lands (async image
 * thumb metadata from the file-worker, `meta.processingFailed`, signature
 * updates). Those re-emits must update the cached row — dropping them leaves
 * stale bubbles (e.g. full-size original instead of the thumb) until a reload.
 *
 * Merge defined fields only: some `newMessage` payloads are partial (same rule
 * as the legacy messages reducer).
 *
 * Voice streaming caveat: finalizeTurn persists the full reply (emitting
 * `newMessage`) while the word-by-word pacer is still revealing. Keep the
 * on-screen prefix so the bubble does not flash the full text and then shrink
 * back to partial.
 */
const upsertMessageIntoListDraft = (draft, message) => {
  if (!draft?.messages) {
    return;
  }
  const idx = draft.messages.findIndex(m => m._id === message._id);
  if (idx < 0) {
    draft.messages.unshift({ ...message, temp: false });
    return;
  }
  const existing = draft.messages[idx];
  const merged = mergeMessagePatch(existing, { ...message, temp: false });
  const revealed = existing?.text || '';
  const incoming = message.text || '';
  const keepRevealed =
    revealed.length > 0 && incoming.length > revealed.length && incoming.startsWith(revealed);
  draft.messages[idx] = keepRevealed ? { ...merged, text: revealed } : merged;
};

export default upsertMessageIntoListDraft;
